var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-1340 -2659.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_5",
    "data-name": "Union 5",
    transform: "translate(-8294 -1962.155)",
    fill: "rgba(255,255,255,0.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9686.5,4622a52.5,52.5,0,1,1-52.5,52.5A52.5,52.5,0,0,1,9686.5,4622Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9686.5 4626 C 9679.951171875 4626 9673.599609375 4627.28173828125 9667.623046875 4629.8095703125 C 9661.84765625 4632.25244140625 9656.6611328125 4635.75 9652.205078125 4640.205078125 C 9647.75 4644.66064453125 9644.251953125 4649.84765625 9641.8095703125 4655.62255859375 C 9639.2822265625 4661.599609375 9638 4667.95068359375 9638 4674.5 C 9638 4681.04931640625 9639.2822265625 4687.400390625 9641.8095703125 4693.37744140625 C 9644.251953125 4699.15234375 9647.75 4704.33935546875 9652.205078125 4708.794921875 C 9656.6611328125 4713.25 9661.84765625 4716.74755859375 9667.623046875 4719.1904296875 C 9673.599609375 4721.71826171875 9679.951171875 4723 9686.5 4723 C 9693.048828125 4723 9699.400390625 4721.71826171875 9705.376953125 4719.1904296875 C 9711.15234375 4716.74755859375 9716.3388671875 4713.25 9720.794921875 4708.794921875 C 9725.25 4704.33935546875 9728.748046875 4699.15234375 9731.1904296875 4693.37744140625 C 9733.7177734375 4687.400390625 9735 4681.04931640625 9735 4674.5 C 9735 4667.95068359375 9733.7177734375 4661.599609375 9731.1904296875 4655.62255859375 C 9728.748046875 4649.84765625 9725.25 4644.66064453125 9720.794921875 4640.205078125 C 9716.3388671875 4635.75 9711.15234375 4632.25244140625 9705.376953125 4629.8095703125 C 9699.400390625 4627.28173828125 9693.048828125 4626 9686.5 4626 M 9686.5 4622 C 9715.4951171875 4622 9739 4645.5048828125 9739 4674.5 C 9739 4703.4951171875 9715.4951171875 4727 9686.5 4727 C 9657.5048828125 4727 9634 4703.4951171875 9634 4674.5 C 9634 4645.5048828125 9657.5048828125 4622 9686.5 4622 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(1341.329 2681.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(23 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M75.3,12.043,56.769,1.354a10.188,10.188,0,0,0-10.149,0L28.084,12.043A10.188,10.188,0,0,0,23,20.845V42.208a10.188,10.188,0,0,0,5.084,8.8L46.619,61.7a10.187,10.187,0,0,0,10.149,0L75.3,51.01a10.188,10.188,0,0,0,5.084-8.8V20.845A10.188,10.188,0,0,0,75.3,12.043Zm.158,30.164a5.247,5.247,0,0,1-2.619,4.534L54.308,57.431a5.247,5.247,0,0,1-5.228,0L30.545,46.742a5.248,5.248,0,0,1-2.619-4.534V20.845a5.247,5.247,0,0,1,2.619-4.534L49.08,5.622a5.248,5.248,0,0,1,5.228,0L72.843,16.311a5.248,5.248,0,0,1,2.619,4.534Z",
    transform: "translate(-23 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M143,181.457l-9.148-7.742a2.463,2.463,0,0,0-3.182,3.761l6.926,5.861-6.926,5.861a2.463,2.463,0,1,0,3.182,3.761L143,185.218A2.464,2.464,0,0,0,143,181.457Z",
    transform: "translate(-116.642 -151.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M265.757,298.859H254.674a2.463,2.463,0,0,0,0,4.927h11.083a2.463,2.463,0,0,0,0-4.927Z",
    transform: "translate(-223.983 -262.054)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRt2);
export default __webpack_public_path__ + "static/media/rt2.b66d1a457fdae07459b927048c76d5b3.svg";
export { ForwardRef as ReactComponent };